import { useAppSelector } from "@/lib/hooks/redux";
import { RootState, VersionedStringFormState } from "@/lib/redux/types";
import { ValidatedFormFieldConfig } from "@evergiving/common/dist/es2015/form";
import { useFieldValidationErrors } from "@/lib/hooks/useFieldValidationErrors";
import { normalizeFieldValue } from "@/lib/misc/validations";

export function useShowErrors(
  config: ValidatedFormFieldConfig,
  name: keyof VersionedStringFormState,
  currentValue: string
) {
  const normalizedValue = normalizeFieldValue(currentValue);
  const hasBeenEdited = useAppSelector(
    (state: RootState) => state[name].version > 0
  );
  const hasBeenFlagged = useAppSelector(
    (state: RootState) => state.errors[name]
  );
  const isBeingEdited = useAppSelector(
    (state: RootState) => state[name].value !== normalizedValue
  );
  const fieldValidationErrors = useFieldValidationErrors(config);
  return (
    (hasBeenEdited || hasBeenFlagged) &&
    !isBeingEdited &&
    fieldValidationErrors.forValue(normalizedValue).length > 0
  );
}
